function isRecord(value: unknown): value is Record<PropertyKey, unknown> {
	return typeof value === 'object' && value !== null;
}

function asStatusCode(value: unknown): number | undefined {
	return typeof value === 'number' ? value : undefined;
}

export function getErrorStatusCode(error: unknown): number | undefined {
	if (!isRecord(error)) return undefined;

	return asStatusCode(error.statusCode)
		?? asStatusCode(error.status)
		?? (isRecord(error.response) ? asStatusCode(error.response.status) : undefined);
}
